import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Gpu } from '../models/gpu';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GpusService {
  private _collection$: Subject<any> = new Subject();
  private _item$: Subject<any> = new Subject();
  get collection$() {
    return this._collection$.asObservable();
  }

  constructor(private http: HttpClient) {}

  public load(teamName: string): Observable<any> {
    this.http.get(`${ConfigService.apiUrl}/gpus/${teamName}`).subscribe((response: any) => {
      this._collection$.next(response);
    });

    return this._collection$.asObservable();
  }

  public countGpus(teamName): Observable<any> {
    this.http.get(`${ConfigService.apiUrl}/count-gpus/${teamName}`).subscribe((response: any) => {
      this._collection$.next(response);
    });

    return this._collection$.asObservable();
  }
}
